// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  background: var(--bg-secondary);
  border-right: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  transition: width var(--transition-normal);
  z-index: 100;
}

.sidebar.open {
  width: 300px;
}

.sidebar.closed {
  width: 70px;
}

/* Header */
.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-md);
  border-bottom: 1px solid var(--border-color);
  min-height: 60px;
}

.logo {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.logo-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--accent-blue);
}

.logo-text {
  font-weight: 600;
  font-size: 1.1rem;
  color: var(--text-primary);
}

.toggle-btn {
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
  width: 28px;
  height: 28px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
}

.toggle-btn:hover {
  background: var(--bg-card-hover);
  color: var(--text-primary);
  border-color: var(--accent-blue);
}

/* Navigation */
.sidebar-nav {
  flex: 1 1;
  overflow-y: auto;
  padding: var(--spacing-md);
  display: flex;
  flex-direction: column;
}

.nav-section {
  flex: 1 1;
}

.nav-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--spacing-md);
  padding: 0 var(--spacing-sm);
}

.nav-title {
  font-size: 0.7rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--text-muted);
  margin: 0;
}

.location-count {
  font-size: 0.7rem;
  padding: 2px 8px;
  background: var(--bg-card);
  border-radius: var(--radius-sm);
  color: var(--text-secondary);
}

.location-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
}

.location-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-sm) var(--spacing-md);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all var(--transition-fast);
  position: relative;
  border: 1px solid transparent;
}

.location-item:hover {
  background: var(--bg-card);
}

.location-item.active {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(59, 130, 246, 0.1));
  border-color: var(--accent-blue);
}

.location-main {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  min-width: 0;
  flex: 1 1;
}

.location-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--text-muted);
}

.weather-icon-small {
  width: 32px;
  height: 32px;
}

.location-info {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.location-name {
  font-weight: 500;
  color: var(--text-primary);
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.location-region {
  font-size: 0.7rem;
  color: var(--text-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.location-weather {
  display: flex;
  align-items: center;
  margin-right: var(--spacing-md);
}

.location-temp {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 0.9rem;
  white-space: nowrap;
}

.remove-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0;
  background: var(--accent-red);
  border: none;
  color: white;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity var(--transition-fast);
}

.location-item:hover .remove-btn {
  opacity: 1;
}

.remove-btn:hover {
  background: #dc2626;
}

/* Add Location */
.add-location {
  margin-top: var(--spacing-lg);
  padding-top: var(--spacing-lg);
  border-top: 1px solid var(--border-color);
}

.add-btn {
  width: 100%;
  padding: var(--spacing-md);
  background: transparent;
  border: 2px dashed var(--border-color);
  border-radius: var(--radius-md);
  color: var(--text-secondary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
  transition: all var(--transition-fast);
  font-size: 0.9rem;
}

.add-btn:hover {
  border-color: var(--accent-blue);
  color: var(--accent-blue);
  background: rgba(59, 130, 246, 0.1);
}

.add-form {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}

.add-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 12px;
  color: var(--text-muted);
  pointer-events: none;
}

.add-input {
  width: 100%;
  padding: var(--spacing-sm) var(--spacing-md);
  padding-left: 36px;
  background: var(--bg-card);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  color: var(--text-primary);
  font-size: 0.9rem;
  outline: none;
  transition: border-color var(--transition-fast);
}

.add-input:focus {
  border-color: var(--accent-blue);
}

.add-input.error {
  border-color: var(--accent-red);
}

.add-input::placeholder {
  color: var(--text-muted);
}

.add-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.add-error {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  color: var(--accent-red);
  font-size: 0.8rem;
  padding: 0 var(--spacing-xs);
}

.add-hint {
  font-size: 0.75rem;
  color: var(--text-muted);
  padding: 0 var(--spacing-xs);
}

.add-actions {
  display: flex;
  gap: var(--spacing-sm);
}

.add-submit,
.add-cancel {
  flex: 1 1;
  padding: var(--spacing-sm) var(--spacing-md);
  border-radius: var(--radius-md);
  cursor: pointer;
  font-size: 0.85rem;
  transition: all var(--transition-fast);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-xs);
}

.add-submit {
  background: var(--accent-blue);
  border: none;
  color: white;
}

.add-submit:hover:not(:disabled) {
  background: #2563eb;
}

.add-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.add-cancel {
  background: transparent;
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
}

.add-cancel:hover:not(:disabled) {
  background: var(--bg-card);
  border-color: var(--text-muted);
}

.btn-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Footer */
.sidebar-footer {
  padding: var(--spacing-md);
  border-top: 1px solid var(--border-color);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}

.footer-item {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  font-size: 0.8rem;
}

.footer-icon {
  color: var(--text-muted);
}

.footer-label {
  color: var(--text-muted);
  flex: 1 1;
}

.footer-value {
  color: var(--text-secondary);
  font-weight: 500;
}

/* Closed state adjustments */
.sidebar.closed .location-item {
  justify-content: center;
  padding: var(--spacing-sm);
}

.sidebar.closed .location-icon {
  margin: 0;
}

.sidebar.closed .toggle-btn {
  margin-left: auto;
  margin-right: auto;
}

.sidebar.closed .sidebar-header {
  flex-direction: column;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm);
}

/* Scrollbar */
.sidebar-nav::-webkit-scrollbar {
  width: 4px;
}

.sidebar-nav::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-nav::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 2px;
}

.sidebar-nav::-webkit-scrollbar-thumb:hover {
  background: var(--text-muted);
}`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,+BAA+B;EAC/B,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA,eAAe;AACf;EACE,SAAO;EACP,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4CAA4C;EAC5C,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qFAAqF;EACrF,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,uBAAuB;EACvB,sCAAsC;EACtC,+BAA+B;EAC/B,4BAA4B;EAC5B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4CAA4C;EAC5C,kBAAkB;EAClB,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;EACxB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,SAAO;EACP,4CAA4C;EAC5C,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,WAAW;AACX;EACE,0BAA0B;EAC1B,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,SAAO;AACT;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,cAAc;AACd;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  background: var(--bg-secondary);\n  border-right: 1px solid var(--border-color);\n  display: flex;\n  flex-direction: column;\n  transition: width var(--transition-normal);\n  z-index: 100;\n}\n\n.sidebar.open {\n  width: 300px;\n}\n\n.sidebar.closed {\n  width: 70px;\n}\n\n/* Header */\n.sidebar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--spacing-md);\n  border-bottom: 1px solid var(--border-color);\n  min-height: 60px;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n}\n\n.logo-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--accent-blue);\n}\n\n.logo-text {\n  font-weight: 600;\n  font-size: 1.1rem;\n  color: var(--text-primary);\n}\n\n.toggle-btn {\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  color: var(--text-secondary);\n  width: 28px;\n  height: 28px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n}\n\n.toggle-btn:hover {\n  background: var(--bg-card-hover);\n  color: var(--text-primary);\n  border-color: var(--accent-blue);\n}\n\n/* Navigation */\n.sidebar-nav {\n  flex: 1;\n  overflow-y: auto;\n  padding: var(--spacing-md);\n  display: flex;\n  flex-direction: column;\n}\n\n.nav-section {\n  flex: 1;\n}\n\n.nav-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--spacing-md);\n  padding: 0 var(--spacing-sm);\n}\n\n.nav-title {\n  font-size: 0.7rem;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--text-muted);\n  margin: 0;\n}\n\n.location-count {\n  font-size: 0.7rem;\n  padding: 2px 8px;\n  background: var(--bg-card);\n  border-radius: var(--radius-sm);\n  color: var(--text-secondary);\n}\n\n.location-list {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-xs);\n}\n\n.location-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--spacing-sm) var(--spacing-md);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  position: relative;\n  border: 1px solid transparent;\n}\n\n.location-item:hover {\n  background: var(--bg-card);\n}\n\n.location-item.active {\n  background: linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(59, 130, 246, 0.1));\n  border-color: var(--accent-blue);\n}\n\n.location-main {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  min-width: 0;\n  flex: 1;\n}\n\n.location-icon {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: var(--text-muted);\n}\n\n.weather-icon-small {\n  width: 32px;\n  height: 32px;\n}\n\n.location-info {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.location-name {\n  font-weight: 500;\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.location-region {\n  font-size: 0.7rem;\n  color: var(--text-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.location-weather {\n  display: flex;\n  align-items: center;\n  margin-right: var(--spacing-md);\n}\n\n.location-temp {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  white-space: nowrap;\n}\n\n.remove-btn {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  opacity: 0;\n  background: var(--accent-red);\n  border: none;\n  color: white;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: opacity var(--transition-fast);\n}\n\n.location-item:hover .remove-btn {\n  opacity: 1;\n}\n\n.remove-btn:hover {\n  background: #dc2626;\n}\n\n/* Add Location */\n.add-location {\n  margin-top: var(--spacing-lg);\n  padding-top: var(--spacing-lg);\n  border-top: 1px solid var(--border-color);\n}\n\n.add-btn {\n  width: 100%;\n  padding: var(--spacing-md);\n  background: transparent;\n  border: 2px dashed var(--border-color);\n  border-radius: var(--radius-md);\n  color: var(--text-secondary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-sm);\n  transition: all var(--transition-fast);\n  font-size: 0.9rem;\n}\n\n.add-btn:hover {\n  border-color: var(--accent-blue);\n  color: var(--accent-blue);\n  background: rgba(59, 130, 246, 0.1);\n}\n\n.add-form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n}\n\n.add-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input-icon {\n  position: absolute;\n  left: 12px;\n  color: var(--text-muted);\n  pointer-events: none;\n}\n\n.add-input {\n  width: 100%;\n  padding: var(--spacing-sm) var(--spacing-md);\n  padding-left: 36px;\n  background: var(--bg-card);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  color: var(--text-primary);\n  font-size: 0.9rem;\n  outline: none;\n  transition: border-color var(--transition-fast);\n}\n\n.add-input:focus {\n  border-color: var(--accent-blue);\n}\n\n.add-input.error {\n  border-color: var(--accent-red);\n}\n\n.add-input::placeholder {\n  color: var(--text-muted);\n}\n\n.add-input:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.add-error {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-xs);\n  color: var(--accent-red);\n  font-size: 0.8rem;\n  padding: 0 var(--spacing-xs);\n}\n\n.add-hint {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n  padding: 0 var(--spacing-xs);\n}\n\n.add-actions {\n  display: flex;\n  gap: var(--spacing-sm);\n}\n\n.add-submit,\n.add-cancel {\n  flex: 1;\n  padding: var(--spacing-sm) var(--spacing-md);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: all var(--transition-fast);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-xs);\n}\n\n.add-submit {\n  background: var(--accent-blue);\n  border: none;\n  color: white;\n}\n\n.add-submit:hover:not(:disabled) {\n  background: #2563eb;\n}\n\n.add-submit:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.add-cancel {\n  background: transparent;\n  border: 1px solid var(--border-color);\n  color: var(--text-secondary);\n}\n\n.add-cancel:hover:not(:disabled) {\n  background: var(--bg-card);\n  border-color: var(--text-muted);\n}\n\n.btn-spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Footer */\n.sidebar-footer {\n  padding: var(--spacing-md);\n  border-top: 1px solid var(--border-color);\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-sm);\n}\n\n.footer-item {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  font-size: 0.8rem;\n}\n\n.footer-icon {\n  color: var(--text-muted);\n}\n\n.footer-label {\n  color: var(--text-muted);\n  flex: 1;\n}\n\n.footer-value {\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n/* Closed state adjustments */\n.sidebar.closed .location-item {\n  justify-content: center;\n  padding: var(--spacing-sm);\n}\n\n.sidebar.closed .location-icon {\n  margin: 0;\n}\n\n.sidebar.closed .toggle-btn {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.sidebar.closed .sidebar-header {\n  flex-direction: column;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-sm);\n}\n\n/* Scrollbar */\n.sidebar-nav::-webkit-scrollbar {\n  width: 4px;\n}\n\n.sidebar-nav::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb {\n  background: var(--border-color);\n  border-radius: 2px;\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb:hover {\n  background: var(--text-muted);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
